import { DPR_1, DPR_2 } from '../constants';

const CLOUDINARY_PATH = 'https://fiverr-res.cloudinary.com',
    ASSET_PATH = 'general_assets/logged_out_homepage/assets';

const getImagePath = ({width, dpr, componentDirectory, img}) => {
    const imgTransform = `q_auto,f_auto,w_${width},${dpr}`,
        imgPath = `${componentDirectory}/${img}`;

    return (`${CLOUDINARY_PATH}/${imgTransform}/${ASSET_PATH}/${imgPath}`);
};

const getSrcSetImagePath = ({width, componentDirectory, img}) => `${getImagePath({width, dpr: DPR_1, componentDirectory, img})} 1x, ${getImagePath({width, dpr: DPR_2, componentDirectory, img})} 2x`;

export { getImagePath, getSrcSetImagePath };
